<template>
  <v-card class="mx-auto" flat="" outlined="">
    <v-list-item three-line>
      <v-list-item-content>
        <div class="overline mb-4">Response Rate</div>
        <v-list-item-title class="headline mb-1">{{
          metric
        }}</v-list-item-title>
        <v-list-item-subtitle>Answers: {{ total }}</v-list-item-subtitle>
        <v-list-item-subtitle>Questions: {{ questions }}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    <v-overlay :absolute="true" :value="isLoading" opacity="0.2" z-index="1">
      <v-progress-circular indeterminate size="32"></v-progress-circular>
    </v-overlay>
  </v-card>
</template>

<script>
import services from "@/services/index.js";

export default {
  props: ["course"],
  computed: {
    metric() {
      return `${Math.round((this.total / this.questions) * 100)}%`;
    },
    total() {
      if (
        !this.short ||
        !Number.isSafeInteger(this.short.count) ||
        !this.choice ||
        !Number.isSafeInteger(this.choice.count) ||
        !this.open ||
        !Number.isSafeInteger(this.open.count)
      ) {
        return 0;
      } else {
        return this.short.count + this.choice.count + this.open.count;
      }
    }
  },
  data: () => ({
    isLoading: false,
    short: {
      count: 0,
      correct: 0,
      incorrect: 0,
      ungraded: 0
    },
    choice: {
      count: 0,
      correct: 0,
      incorrect: 0,
      ungraded: 0
    },
    open: {
      count: 0,
      correct: 0,
      incorrect: 0,
      ungraded: 0
    },
    questions: 0
  }),
  methods: {
    async onLoad() {
      this.isLoading = true;
      try {
        let data = null;
        if (!this.course) {
          data = await services.metrics.get();
        } else {
          data = await services.metrics.get({ course: this.course });
        }
        this.short = data.interactions.short;
        this.choice = data.interactions.choice;
        this.open = data.interactions.open;
        this.questions = data.content.questions;
      } catch (err) {
        console.error(err);
      }
      this.isLoading = false;
    }
  },
  mounted() {
    this.onLoad();
  }
};
</script>

<style></style>
